export interface LetterHeadList {
  count: number;
  next: string | null;
  previous: string | null;
  results: LetterHead[];
}

export interface LetterHead {
  id: string;
  name: string;
  header_type: string;
  is_default: boolean;
  header_html: string;
  header_image?: string | File | null;
  header_image_width?: number;
  header_image_height?: number;
  header_image_align?: string;
  footer_type: string;
  footer_html: string;
  footer_image?: string | File | null;
  footer_image_width?: number;
  footer_image_height?: number;
  footer_image_align?: string;
}

export interface LetterHeadPayload {
  name: string;
  header_type: string;
  header_html?: string;
  header_image?: string | File | null;
  header_image_width?: number;
  header_image_height?: number;
  header_image_align?: string;
  footer_type: string;
  footer_html?: string;
  footer_image?: string | File | null;
  footer_image_width?: number;
  footer_image_height?: number;
  footer_image_align?: string;
  is_default: boolean;
}

export interface NotificationRecipient {
  receiver_by_document_field: string;
  receiver_by_role: string | null;
  condition: string;
}

export interface Notification {
  id: string;
  name: string;
  channel: number;
  subject: string;
  send_alert_on: number;
  schema_name: string;
  sender_email: string;
  condition: string;
  message: string;
  attach_print: boolean;
  print_format: string;
  reference_field: string | null;
  days_before_or_after: number | null;
  notification_recipients: NotificationRecipient[];
  created_at?: string;
  updated_at?: string;
}

export interface NotificationPayload {
  name: string;
  channel: number;
  subject: string;
  send_alert_on: number;
  schema_name: string;
  sender_email: string;
  condition: string;
  message: string;
  attach_print: boolean;
  print_format: string;
  reference_field: string | null;
  days_before_or_after: number | null;
  notification_recipients: NotificationRecipient[];
}

export interface NotificationList {
  count: number;
  next: string | null;
  previous: string | null;
  results: Notification[];
}

export interface NotificationFormValues {
  name: string;
  subject: string;
  schema_name: string;
  channel: number;
  send_alert_on: number;
  sender_email?: string;
  condition?: string;
  message: string;
  attach_print?: boolean;
  print_format?: string;
  reference_field?: string;
  days_before_or_after?: number;
  notification_recipients?: NotificationRecipient[];
}

export interface ChannelOption {
  value: string;
  label: string;
}

export interface EventOption {
  value: string;
  label: string;
}

export interface ReferenceDateOption {
  value: number;
  label: string;
}

export interface ApiErrorResponse {
  response?: {
    data?: {
      error?: string | Record<string, string[] | string>;
      message?: string;
    };
  };
}

export const CHANNEL_OPTIONS: ChannelOption[] = [
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS" },
  { value: "system", label: "System Notification" },
  { value: "whatsapp", label: "WhatsApp" },
];

export const EVENT_OPTIONS: EventOption[] = [
  { value: "new", label: "New" },
  { value: "save", label: "Save" },
  { value: "days_after", label: "Days After" },
  { value: "days_before", label: "Days Before" },
  { value: "value_change", label: "Value Change" },
];

export const REFERENCE_DATE_OPTIONS: ReferenceDateOption[] = [
  { value: 1, label: "creation (Created On)" },
  { value: 2, label: "modified (Last Modified Date)" },
];

export const SAMPLE_NOTIFICATION_PAYLOAD: NotificationPayload = {
  name: "Notify on Teacher Schema Record Update",
  channel: 1,
  subject: "Record Update in {{ doc.schema_name }} Schema!",
  send_alert_on: 5,
  schema_name: "teacher",
  sender_email: "4978479b-f1ff-4047-a336-a3b67d419167",
  condition: "",
  message:
    "Hello,<br><br>A new Record has been Updated to the {{ doc.schema_name }} schema.<br><strong>Schema Name:</strong> {{ doc.schema_name }} <br><strong>New Data:</strong> {{ doc.new_data }} <br><strong>Old Data:</strong> {{ doc.old_data }} <br><strong>Which Contains this fields:</strong> {{ doc.fname }} and {{ doc.lname }}<br>",
  attach_print: false,
  print_format: "",
  reference_field: null,
  days_before_or_after: null,
  notification_recipients: [
    {
      receiver_by_document_field: "email",
      receiver_by_role: null,
      condition: "",
    },
  ],
};
